<div class="modal">
    <h2 mat-dialog-title>{{data.title}}</h2>
    <div class="body" mat-dialog-content [innerHTML]="data.texto"></div>
    <!-- Cierra directamente el modal. -->
    <div class="footer">
        <button class="btn ml2 btn-primary" [mat-dialog-close]="true">{{data.buttonConfirm}}</button>
    </div>
</div>